"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const fragments_1 = require("../fragments");
const notifi_axios_utils_1 = require("@notifi-network/notifi-axios-utils");
const DEPENDENCIES = [...fragments_1.emailTargetFragmentDependencies, fragments_1.emailTargetFragment];
const MUTATION = `
mutation sendEmailTargetVerificationRequest(
  $targetId: String!
) {
  sendEmailTargetVerificationRequest(sendTargetConfirmationRequestInput:{
    targetId: $targetId
  }) {
    ...emailTargetFragment
  }
}
`.trim();
const sendEmailTargetVerificationRequestImpl = (0, notifi_axios_utils_1.makeRequest)((0, notifi_axios_utils_1.collectDependencies)(...DEPENDENCIES, MUTATION), 'sendEmailTargetVerificationRequest');
exports.default = sendEmailTargetVerificationRequestImpl;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2VuZEVtYWlsVGFyZ2V0VmVyaWZpY2F0aW9uUmVxdWVzdEltcGwuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9saWIvbXV0YXRpb25zL3NlbmRFbWFpbFRhcmdldFZlcmlmaWNhdGlvblJlcXVlc3RJbXBsLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7O0FBQUEsNENBR3NCO0FBQ3RCLDJFQUc0QztBQU01QyxNQUFNLFlBQVksR0FBRyxDQUFDLEdBQUcsMkNBQStCLEVBQUUsK0JBQW1CLENBQUMsQ0FBQztBQUUvRSxNQUFNLFFBQVEsR0FBRzs7Ozs7Ozs7OztDQVVoQixDQUFDLElBQUksRUFBRSxDQUFDO0FBRVQsTUFBTSxzQ0FBc0MsR0FBRyxJQUFBLGdDQUFXLEVBSXhELElBQUEsd0NBQW1CLEVBQUMsR0FBRyxZQUFZLEVBQUUsUUFBUSxDQUFDLEVBQzlDLG9DQUFvQyxDQUNyQyxDQUFDO0FBRUYsa0JBQWUsc0NBQXNDLENBQUMifQ==